import SheetsContainer from '../../components/sheets/container.vue';
import EventEmitter from '@/utils/EventEmitter';

const Plugin = {
  install(app) {
    if (this.installed) return;
    this.installed = true;

    const subscription = new EventEmitter();

    function show(...args) {
      let [sheetType, options] = args;
      subscription.$emit('show', { sheetType, options });
    }

    function hide(...args) {
      let [sheetType] = args;
      subscription.$emit('hide', { sheetType });
    }

    app.config.globalProperties.$sheets = {
      show,
      hide,
      subscription,
    };

    app.component('SheetsContainer', SheetsContainer);
  },
};

export default Plugin;
